import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "./ui/accordion";
import { capabilities, capabilitiesImage } from "../mock";

const AccordionSections = ({ onSignup }) => {
  return (
    <section className="ws-split" id="diensten">
      <div className="ws-split-inner">
        <div>
          <span className="ws-tag"><span className="dot" />DIENSTEN</span>
          <h2>Wat je van ons kan verwachten</h2>
          <Accordion type="single" collapsible defaultValue="item-0">
            {capabilities.map((item, i) => (
              <AccordionItem key={i} value={`item-${i}`} className="ws-accordion-item">
                <AccordionTrigger className="ws-accordion-trigger">{item.title}</AccordionTrigger>
                <AccordionContent className="ws-accordion-content">{item.text}</AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
          <button className="ws-btn ws-btn-lime" onClick={onSignup}>
            Vraag account aan
          </button>
        </div>
        <div className="ws-split-img">
          <img src={capabilitiesImage} alt="WS Global Trading distributie" loading="lazy" />
        </div>
      </div>
    </section>
  );
};

export default AccordionSections;
